module.exports = __webpack_public_path__ + "static/media/wx.35ffa6fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/inviteNew/wx.png
// module id = 1958
// module chunks = 4